import { option } from 'fp-ts';
import { getNodeBounds } from '../GraphNode';
import { fitToViewport } from '../helpers/fitToViewport';
import type { GraphRendererPlugin } from './GraphRendererPlugin';

const FIT_EDGE_OFFSET = 200;

export const fitNodeToView: GraphRendererPlugin = (pluginInterface) => {
  const getMinViewportDimension = () =>
    Math.min(
      pluginInterface.viewport.screenWidth,
      pluginInterface.viewport.screenHeight,
    );

  pluginInterface.bindGraphCommandEventListener('fitNodeToView', (event) => {
    const node = pluginInterface.nodeDisplayObjects.get(event.nodeData.id);
    if (node) {
      const bounds = getNodeBounds(event.nodeData, node);

      if (option.isNone(bounds)) {
        return;
      }

      const minViewportDimension = getMinViewportDimension();

      fitToViewport(
        pluginInterface.viewport,
        minViewportDimension / 4 + FIT_EDGE_OFFSET,
      )(bounds.value);
    }
  });
};
